import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { Card, Button, Row, Col, Badge, Modal } from "react-bootstrap"
import QRCode from "qrcode.react" // Make sure to install this package
import api from "@/api/api"
import { useAppDispatch, useAppSelector } from "../../redux/store"
import Spinner from "react-bootstrap/Spinner"
import { ToastContainer, toast, Slide } from "react-toastify"
import { useForm } from "react-hook-form"
import { z } from "zod"
import { zodResolver } from "@hookform/resolvers/zod"
import { FaAngleRight } from "react-icons/fa6"
import { FiChevronLeft } from "react-icons/fi"
import { BsFillPatchCheckFill } from "react-icons/bs"

import { IoMdAdd } from "react-icons/io"
import Events from "../../components/Events/Events"
import Paginator from "../../components/utils/Pagination/Pagination"
import { resetInvitationState } from "@/redux/slices/invite/invitationSlice"
import { CiSearch } from "react-icons/ci"
import { RiDeleteBin6Line } from "react-icons/ri"
import { getBalance } from "@/redux/slices/balance/balanceSlice"
import NoInviteHome from "./NoInviteHome"
// import { IEvent } from "@/components/Events/types"
import { getEvents, setCurrentPage } from "@/redux/slices/events/eventsSlice"
const messageSchema = z.object({
  message: z
    .string()
    .min(5, "Message must be at least 5 characters long")
    .max(500, "Message cannot exceed 500 characters"),
})
// import { LinearProgress, Chip } from "@mui/material"
const BASE_URL = import.meta.env.VITE_REACT_APP_API_BASE_URL
function formatDate(dateString: string): string {
  // Parse the input date string into a Date object
  const date = new Date(dateString)

  // Options for formatting the date in the desired format
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "short",
    day: "numeric",
  }

  // Use toLocaleDateString to format the date
  return date.toLocaleDateString("en-US", options)
}

// Example usage:
const formattedDate = formatDate("2024-11-27")

const sampleData = [
  {
    pattern: "https://dev-api.mazoom.sa/api/upload/files/1731091872.jpeg",
    name: "Weeding Party of Hannah & Bradley ",
    noQuasts: "98",
  },
  {
    pattern: "https://dev-api.mazoom.sa/api/upload/files/1731100179.jpeg",
    name: "Wilddigital - Shouteast Asia Conference 2025 ",
    noQuasts: "98",
  },
  {
    pattern: "https://dev-api.mazoom.sa/api/upload/files/1725595646.jpeg",
    name: "Weeding Party of Adam & Eva ",
    noQuasts: "98",
  },
]

const MyInvitations = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const { phone, lang } = useAppSelector((state) => state.auth)
  const [showDeleteEvent, setShowDeleteEvent] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const [loadingDeleteEvent, setLoadingDeleteEvent] = useState(false)
  const [selectedInvite, setSelectedInvite] = useState<any>(null)
  const { data, total_pages, current_page, isLoading, total } = useAppSelector(
    (state) => state.events,
  )
  const handleCloseDeleteEvent = () => {
    setShowDeleteEvent(false)
  }
  const handleDeleteEvent = (data: any) => {
    setSelectedInvite(data)
    setShowDeleteEvent(true)
  }

  const [filter, setFilter] = useState({
    sort: "desc",
    order: "orderBy",
    searchValue: "",
    status: "",
  })

  const onPageChanged = (page: number) => {
    dispatch(setCurrentPage(page))
    dispatch(getEvents(filter))
  }

  useEffect(() => {
    dispatch(setCurrentPage(1))
    dispatch(getEvents(filter)).then((data: any) => {})
  }, [dispatch, filter.sort, filter.searchValue, filter.status, refresh])

  const handleSubmitDeleteEvent = async () => {
    setLoadingDeleteEvent(true)
    try {
      const deleteEvent = await api.events.deleteEvent(
        selectedInvite ? selectedInvite?.event_id : "",
      )
      if (deleteEvent) {
        setLoadingDeleteEvent(false)
        // setShowDeleteContact(false)
        toast.success("Event deleted successfully")
        setShowDeleteEvent(false)
        setRefresh(!refresh)
        dispatch(getBalance()).then((data) => {
          // console.log("data added")
        })
      } else {
        setShowDeleteEvent(false)
        toast.error("Event Not deleted ")
      }
    } catch (err: any) {
      setLoadingDeleteEvent(false)
      setShowDeleteEvent(false)

      // setShowDeleteContact(false)
      toast.error("Error while deleting card ")
    }
  }
  return (
    <div className="container">
      {
        <div className="w-100 row  mb-4 me-4 align-items-center ">
          <div
            className="col-12 col-sm-12  col-md-12  col-lg-3  mb-2 mb-lg-0 d-flex flex-wrap"
            // style={{ maxWidth: "50px" }}
          >
            <h5 className="fs-3 fw-bold d-flex flex-wrap">
              {t("event.yourInvitations")}
            </h5>
          </div>
          <div className="col-12 col-sm-6 col-md-8 col-lg-6 mb-2 mb-lg-0 position-relative">
            {/* Input Field */}
            <input
              type="text"
              className="form-control pe-5" // Add padding to the right for space for the icon
              placeholder={t("invitation.searchInvitations")}
              value={filter.searchValue}
              onChange={(e) => {
                setFilter((prev) => ({
                  ...prev,
                  searchValue: e.target.value, // Update only searchValue
                }))
              }}
              style={{ height: "45px" }}
            />
            {/* Search Icon */}
            <CiSearch
              className="position-absolute "
              style={{
                top: "50%",
                right: "30px", // Adjust position to your liking
                transform: "translateY(-50%)",
                color: "#6c757d",
                cursor: "pointer",
                // pointerEvents: "none", // Ensures the icon doesn't block input clicks
              }}
            />
          </div>
          <div className="col-12 col-sm-6 col-md-4  col-lg-3 mb-2 mb-lg-0">
            <Link
              className="btn btn event-create"
              style={{
                backgroundColor: "#245192",
                color: "#ffffff",
                // textTransform: "capitalize",
                border: "none",
                textDecoration: "none",
              }}
              to="/add-invite"
              onClick={() => dispatch(resetInvitationState())}
            >
              <IoMdAdd style={{ color: "#ffffff" }} />
              {t("buttons.createInvitation")}
            </Link>
          </div>
        </div>
      }
      {isLoading && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "50vh",
          }}
        >
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      )}

      <div className="d-flex flex-column gap-3 p-0">
        <div className="d-flex flex-column align-items-center gap-3 ps-2 pe-2 ">
          {/* {invitations?.map((invitation: any, index) => ( */}
          {!isLoading &&
            data.length !== 0 &&
            data?.map((invitation: any, index) => (
              <Link
                to={`/invite-details/${invitation?.event_id}`}
                key={index}
                style={{
                  backgroundColor: "white",
                  textDecoration: "none",
                  textTransform: "none",
                }}
                className="row w-100 d-flex flex-row flex-md-row align-items-center justify-content-between p-0"
              >
                {/* Start Section */}
                <div
                  className="col-6 col-md-8 d-flex align-items-center p-3"
                  style={{
                    gap: "1rem",

                    // backgroundColor: "green"
                  }}
                >
                  <div className="ps-0">
                    <div className="d-flex gap-2">
                      {" "}
                      <h5 className="invite-list__title fw-normal m-0 p-0">
                        {invitation?.name}
                      </h5>
                      {invitation?.isPremium == 1 && (
                        <div
                          className="me-0  ms-2"
                          // style={{ marginBottom: "-30px" }}
                        >
                          <BsFillPatchCheckFill style={{ color: "#245192" }} />
                        </div>
                      )}
                    </div>
                    <span
                      className="text-muted p-0 m-0"
                      style={{ fontSize: "14px" }}
                    >
                      {formatDate(invitation?.event_created_date)}
                    </span>
                  </div>
                </div>

                <div
                  className="col-6 col-md-4   p-3 d-flex align-items-right justify-content-end "
                  style={{ textAlign: lang == "ar" ? "left" : "right" }}
                >
                  <div>
                    {" "}
                    <RiDeleteBin6Line
                      style={{
                        color: "grey",
                        marginRight: "6px",
                        marginLeft: "6px",
                      }}
                      onClick={(event: any) => {
                        event.preventDefault() // Prevent the default behavior
                        event.stopPropagation() // Stop the event from bubbling up
                        handleDeleteEvent(invitation) // Execute delete action
                      }}
                    />
                  </div>
                  <Link
                    className="text-reset text-muted"
                    style={{
                      cursor: "pointer",
                      textDecoration: "none",
                      textTransform: "none",
                      color: "#dedede",
                    }}
                    to={`/invite-details/${invitation?.event_id}`}
                  >
                    {lang == "ar" ? (
                      <FiChevronLeft style={{ color: "grey" }} />
                    ) : (
                      <FaAngleRight style={{ color: "grey" }} />
                    )}
                  </Link>
                </div>
              </Link>
            ))}
        </div>
      </div>
      {!isLoading && data.length == 0 && filter?.searchValue == "" && (
        <NoInviteHome />
      )}
      {!isLoading && data.length == 0 && filter?.searchValue != "" && (
        <>
          <NoInviteHome />
          {/* <div
            className="d-flex align-items-center justify-content-center"
            style={{ height: "300px" }}
          >
            {t("invitation.noInvitationFound")}
          </div> */}
        </>
      )}

      {!isLoading && data.length !== 0 ? (
        <>
          <Button
            onClick={() => {
              // setEventsLoadMore(data)
              dispatch(
                setCurrentPage(
                  current_page === total_pages ? 1 : current_page + 1,
                ),
              )
              dispatch(getEvents(filter))
            }}
            className={
              total > data.length
                ? "btn btnloadMore d-lg-none d-sm-flex"
                : "d-none"
            }
          >
            {t("buttons.loadMore")}
          </Button>
          <Paginator
            total_pages={total_pages}
            current_page={current_page}
            onPageChanged={onPageChanged}
          />
        </>
      ) : (
        <></>
      )}

      {/* delete invite modal */}

      <Modal show={showDeleteEvent} onHide={handleCloseDeleteEvent} centered>
        <Modal.Body
          style={{
            marginTop: "-100px",
            // backgroundColor: "red"
          }}
          className=" w-100  m-0 d-flex flex-column justify-content-center align-items-center gap-0"
        >
          <div
            className="ps-5 pe-5 pb-2   m-0 w-100"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignContent: "center",
              minHeight: "300px",
              minWidth: "100px",
            }}
          >
            <div className="d-flex flex-column gap-4 align-items-center justify-content-center">
              {/* <form
                className="d-flex flex-column gap-4 align-items-center justify-content-center"
                onSubmit={handleSubmitDeleteContact}
              > */}
              <h5 className=" fs-3 fw-bold">
                {/* {t("invitation.addNames")} */}
                {t("inviteDetail.areYouSure")}
              </h5>{" "}
              <h5
                style={{
                  position: "relative",
                  paddingBottom: "8px", // Adjust for spacing between text and underline
                }}
              >
                {t("inviteDetail.youAreAboutToDeleteAnInvite")}
              </h5>
              <div className="d-flex justify-content-space-between gap-4 ">
                <button
                  // onClick={(e) => onSubmit(e, "")}
                  className="btn btn-dark w-100 "
                  style={{
                    height: "40px",
                    borderRadius: "5px",
                    backgroundColor: "white",
                    border: "1ps solid grey",
                    color: "black",
                  }} // Ensure it sticks to the bottom
                  onClick={handleCloseDeleteEvent}
                >
                  {t("buttons.cancel")}
                </button>
                <button
                  type="submit"
                  // onClick={(e) => onSubmit(e, "")}
                  className="btn btn-dark  w-100"
                  style={{
                    height: "40px",
                    borderRadius: "5px",
                    backgroundColor: "#20529B",
                    border: "none",
                  }} // Ensure it sticks to the bottom
                  disabled={loadingDeleteEvent}
                  onClick={handleSubmitDeleteEvent}
                >
                  {loadingDeleteEvent ? (
                    <h6 className="mt-1">deleting ...</h6>
                  ) : (
                    t("buttons.delete")
                  )}
                </button>
              </div>
              {/* </form> */}
            </div>
          </div>
          {/* <ToastContainer
            style={{ width: "90%", maxWidth: "400px", fontSize: "18px" }}
          /> */}
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default MyInvitations
